import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Quick.css";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { SIDEBAR_OPTIONS_LIST } from "../../utilities/constants";
import { posLink } from "../../DataApi/pointOfSaleLink";

const QuickAccessComponent = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedLanguage, setSelectedLanguage] = useState("Popular");
  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };
  const navigate = useNavigate();
  let myPoSLink = null;
  let origin = window.location.origin;
  // console.log("origin", origin);
  // console.log("origin", origin);

  const handleClick = async (menuItem) => {
    if (menuItem.link) {
      if (menuItem?.openNewPage)
        return window.open(menuItem.link, "_blank").focus();

      return navigate(menuItem.link);
    }
    try {
      let response = await posLink("point_of_sale.menu_point_root");
      response = JSON.parse(response);
      if (response?.result) {
        // myPoSLink = "http://127.0.0.1:8069" + response?.result?.url;
        myPoSLink = origin + response?.result?.url;
        // console.log("response of pos link api", response, myPoSLink);

        // Open the link in a new tab
        window.open(myPoSLink, "_blank").focus();
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between p-3">
        <div className="ShortCuts-heading">{t["Quick Access"]}</div>

        {/* <div
          className="d-none d-md-inline d-flex "
          style={{ color: "#F8F9FA", borderRadius: "15px" }}
        >
          <span style={{ color: "#B0B7C3" }}>Show by:</span>
          <span style={{ color: "#fff" }}>
            <select
              className="
      bg-light border-0"
              value={selectedLanguage}
              onChange={handleLanguageChange}
            >
              <option>Popular</option>
              <option value="en">English</option>
              <option value="ar">Arabic</option>
            </select>
          </span>
        </div> */}
      </div>
      <div className="container">
        {SIDEBAR_OPTIONS_LIST.filter((item) => item.showDashboard).map(
          (item, index) => (
            <div
              key={index}
              className="card col-lg-4 col-md-6 col-sm-6 col-12 cursor-pointer"
              style={{
                backgroundColor: item.backgroundColor,
                margin: "8px",
                position: "relative",
                maxWidth: "95px",
                maxHeight: "80px",
              }}
            >
              <div
                // to={item.link}
                className=""
                style={{
                  // maxWidth: "230px",
                  // maxHeight: "160px",
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => handleClick(item)}
                activeclassname="active"
              >
                <div
                  className="icon"
                  style={{
                    height: "35px",
                    width: "35px",
                    backgroundImage: `url(${item.icon})`,
                  }}
                ></div>
                <div style={{ fontSize: "9px" }}>{t[item.name]}</div>
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default QuickAccessComponent;
